module.exports = __webpack_public_path__ + "img/fengcai3.9d3ff776.jpg";